
/**
 * Ce tableau répresente l'ensemble des routes ne nécessitant pas
 * la barre d'application par défaut
 */
export const protectedRoutes = [
  '/account/'
]
